import React from "react";
import { useHistory } from "react-router-dom";

import {
  Context,
  fetchTeachingMaterials,
  fetchSchoolGoals,
  notFoundPath,
  guidelinePath,
  projectionPath,
  fetchClasses,
  publishLesson,
  clearTeachingMaterials,
} from "../../../teacherStore";
import SelectPage from "../../../templates/teacher/SelectPage";
import { parseQueryParams } from "../../../libs/Util";
import useWaitApiCall from "../../../hooks/useWaitApiCall";

export default () => {
  const { state, dispatch } = React.useContext(Context);
  const [calling, peep] = useWaitApiCall(state);
  const history = useHistory();
  const classListInParams = parseQueryParams()["classList"];
  const classList = React.useMemo(
    () =>
      classListInParams
        ? classListInParams.split(",").map((classID: string) => Number(classID))
        : null,
    [classListInParams],
  );

  if (!classListInParams) {
    history.push(notFoundPath);
    return null;
  }

  React.useEffect(() => {
    dispatch(fetchClasses());
    dispatch(fetchTeachingMaterials(classList));
    dispatch(fetchSchoolGoals());
    return () => dispatch(clearTeachingMaterials());
  }, [dispatch, classList]);

  const listClassName = React.useMemo(
    () =>
      state.classes
        .filter(cls => classList.includes(cls.id))
        .map(cls => cls.full_name),
    [state.classes, classList],
  );

  const publishLessonFunc = React.useCallback(
    (lesson_id: number) => {
      if (classList) dispatch(peep(publishLesson(classList, lesson_id)));
    },
    [classList, dispatch, peep],
  );

  const openGuideline = React.useCallback(
    (teaching_material_id: number, id: number) => {
      history.push({
        pathname: `${guidelinePath}/${teaching_material_id}`,
        search: `?lesson=${id}&page=1&classList=${classList}`,
      });
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [history],
  );

  const openMaterial = React.useCallback(
    (lesson_id: number) => {
      window.open(
        `${projectionPath}?lesson=${lesson_id}&page=1&classList=${classList}`,
        "_blank",
      );
    },
    [classList],
  );

  return (
    <SelectPage
      teaching_materials={state.teaching_materials}
      classList={listClassName}
      educationGoal={state.school_goals.purpose}
      openGuideline={openGuideline}
      openMaterial={openMaterial}
      onPublishLesson={publishLessonFunc}
      calling={calling}
    />
  );
};
